export default __webpack_public_path__ + "static/GalanoGrotesqueAltRegular-b2fddac47fb0335d68f3d19f789c1a74.ttf";